import React from 'react';

const Support = () => {
  return (
    <div className='p-6 bg-gray-100 flex-1 overflow-auto'>
      <div className='bg-white p-4 rounded shadow-md'>
        <h2 className='text-2xl font-semibold'>Support</h2>
        <p className='mt-4 text-gray-600'>Coming Soon</p>
      </div>
    </div>
  );
};

export default Support;
